import { useEffect, useState } from 'react';
import './dynamicTable.css';

export default function DynamicTable({ endpoint, refreshKey = 0 }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            setData([]);
            try {
                const response = await fetch(endpoint);
                if (!response.ok) throw new Error('Failed to fetch data');
                const json = await response.json();
                setData(Array.isArray(json) ? json : [json]);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [endpoint, refreshKey]);

    if (loading) return <p>Loading table...</p>;
    if (error) return <p>Error: {error}</p>;
    if (!data.length) return <p>No data available</p>;

    const columns = Object.keys(data[0]);

    const renderCell = (value) => {
        if (Array.isArray(value)) {
            // Handle arrays like services inside a service pack
            return value.map((item, i) => (
                <div key={i} className="dynamic-table-nested">
                    {item.serviceId
                        ? `${item.serviceId.id} (${item.serviceId.language}) | ${item.name} | ${item.imageUrl}`
                        : item.name || JSON.stringify(item)}
                </div>
            ));
        } else if (typeof value === 'object' && value !== null) {
            // Handle objects
            if (value.id !== undefined && value.language !== undefined) {
                return `${value.id} (${value.language})`;
            } else if (value.name !== undefined) {
                return `${value.name} | Image: ${value.imageUrl ?? ''}`;
            }
            return JSON.stringify(value);
        } else {
            return value;
        }
    };

    return (
        <div className="dynamic-table-container">
            <table className="dynamic-table">
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th key={col}>{col.replace(/_/g, ' ').toUpperCase()}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, idx) => (
                        <tr key={idx}>
                            {columns.map((col) => (
                                <td key={col}>{renderCell(row[col])}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
